/**
 * Rule Service
 * Handles rule-related API calls
 */

import api from '@/lib/api';
import type { ApiResponse } from '@/lib/api';
import type { Rule } from '@/types/shadow.types';

interface RulesListResponseDto {
  rules: Array<{
    id: string;
    name: string;
    content?: unknown;
    description?: string;
    [key: string]: unknown;
  }>;
  count: number;
}

interface RulesResponseDto {
  rules: Array<{
    id: string;
    name: string;
    content?: unknown;
    description?: string;
    [key: string]: unknown;
  }>;
  count: number;
}

export const ruleService = {
  /**
   * Get all rules for the account
   */
  async getRules(): Promise<Rule[]> {
    try {
      const response = await api.get<ApiResponse<RulesListResponseDto>>('/rules');
      return response.data.data.rules.map((rule): Rule => ({
        id: rule.id,
        name: rule.name,
        content: rule.content,
        description: rule.description
      }));
    } catch (error) {
      console.error('Error fetching rules:', error);
      return [];
    }
  },

  /**
   * Get multiple rules by IDs
   */
  async getRulesByIds(ids: string[]): Promise<Rule[]> {
    if (!ids || ids.length === 0) {
      return [];
    }

    try {
      const response = await api.post<ApiResponse<RulesResponseDto>>('/rules/by-ids', { ids });
      return response.data.data.rules.map((rule): Rule => ({
        id: rule.id,
        name: rule.name,
        content: rule.content,
        description: rule.description
      }));
    } catch (error) {
      console.error('Error fetching rules by IDs:', error);
      return [];
    }
  },
};

